module.exports = __webpack_public_path__ + "media/images/connected-3-d3152923bc144472b9cf0ba2f7380178.jpg";